'use strict';


export default function() {
	return function filter(phoneNumber) {
		if (!phoneNumber) return '';
		var digits = phoneNumber.toString().replace(/[^\d]+/g, '').slice(-10);
		if (digits.length != 10) return phoneNumber;
		return digits.replace(/^(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
	}
}
